"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
/**
* Nom : rgpdPolicy.js
* Description : Ce fichier contient la définition de la page rgpdPolicy 
*               Cette page affiche les informations RGPD / politique de confidentialité
* Date de création : 16 janvier 2026
*/

/* CSS et assets */
// None

/* Bibliothèques et composants */

/* Hook */

/**
* RgpdPolicy : affiche la page qui contient les informations RGPD
*              Un bouton permet de revenir sur la page de connexion
*
* Type : page 
*
* Parametres : 
*  None
*/function RgpdPolicy() {
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 650 ? 'App' : 'App-ss',
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dist.Container, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: screenWidth > 650 ? 'flex-row margin-bottom' : null,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
            children: "Politique de confidentialit\xE9"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: screenWidth > 650 ? 'flex-row justify-center margin-bottom margin-top' : 'grid-1-1 justify-center margin-bottom margin-top',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "link-border",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BackPage, {
              path: "/",
              children: "Retour sur la page de connexion"
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.RGPD, {
          className: "margin"
        })]
      })
    })
  });
}
var _default = exports["default"] = RgpdPolicy;